import { BasicProgramInformation } from '@app/catalog-common';
import { BasicUserInformation } from '@app/security-common';
import { PropertyChangedInformation, Notification } from '@app/shared';

@Notification({
    name: 'ProjectUpdatedNotification'
})
export class ProjectUpdatedNotification {
    public projectId: string;
    public projectName: string | null;
    public program: BasicProgramInformation;
    public changes: PropertyChangedInformation[] = [];
}

@Notification({
    name: 'ProjectCreatedNotification'
})
export class ProjectCreatedNotification {
    public projectId: string;
    public projectName: string | null;
    public program: BasicProgramInformation;
    public changes: PropertyChangedInformation[] = [];
    public createdBy: BasicUserInformation;
}